<div #elTab class="tab"
     (click)="onClick($event)"
     (mouseenter)="onMouseEnter($event)"
     (mouseleave)="onMouseLeave($event)"
     [ngClass]="{'active': activeTab === tabIndex, 'vip-tab': tab === 'VIP专区'}"
     [ngStyle]="activeTab === tabIndex ? getActiveStyle() : ( hovered ? getHoveredStyle() : getStyle())">{{ tab }}
     <span *ngIf="tab === '服务条款'">
      <img class="gg-notice" src="{{'../../../../assets/icon/notice.png'|absUrl}}">
   </span>
</div>
